import {
  createStyleMixin,
  draggableMixin,
  componentNameValidationMixin,
  stretchMixin,
} from '@descope-ui/common/components-mixins';
import { compose } from '@descope-ui/common/utils';
import {
  getComponentName,
  injectStyle,
  observeChildren,
} from '@descope-ui/common/components-helpers';
import { createBaseClass } from '@descope-ui/common/base-classes';

export const componentName = getComponentName('text');

class RawText extends createBaseClass({
  componentName,
  baseSelector: ':host > slot',
}) {
  constructor() {
    super();

    this.attachShadow({ mode: 'open' }).innerHTML = `
    <slot part="text-wrapper"></slot>
    `;

    injectStyle(
      `
      :host {
        display: inline-block;
        line-height: 1em;
      }
      :host > slot {
        width: 100%;
        display: inline-block;
      }
    `,
      this,
    );
  }

  get hideWhenEmpty() {
    return this.getAttribute('hide-when-empty') === 'true';
  }

  init() {
    super.init();

    observeChildren(this, () => {
      const hasChildren = !!this.childNodes.length;
      this.style.display = !hasChildren && this.hideWhenEmpty ? 'none' : '';
    });
  }
}

const { host } = {
  host: { selector: () => ':host' },
};

export const TextClass = compose(
  createStyleMixin({
    mappings: {
      hostWidth: { ...host, property: 'width' },
      hostDirection: { ...host, property: 'direction' },
      fontSize: {},
      textColor: [{ property: 'color' }],
      textLineHeight: { property: 'line-height' },
      textLetterSpacing: { property: 'letter-spacing' },
      textShadow: {},
      textAlign: {},
      textTransform: {},
      fontFamily: {},
      fontStyle: {},
      fontWeight: {},
      borderWidth: {},
      borderStyle: {},
      borderColor: {},
    },
  }),
  stretchMixin({ triggers: [{ attr: 'full-width', value: 'true' }] }),
  draggableMixin,
  componentNameValidationMixin,
)(RawText);
